import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import AdminPagination from '../Admin/Pagination';
import AdminResultsPerPageSelector from '../Admin/ResultsPerPageSelector';

class SharesFooter extends PureComponent {
  render() {
    const {
      sharesTotal,
      page,
      perPage,
      handleChangePage,
      handleChangePerPage,
    } = this.props;

    return (
      <div className="table-footer">
        <AdminResultsPerPageSelector
          perPage={perPage}
          handleChangePerPage={handleChangePerPage}
        />
        <AdminPagination
          total={sharesTotal}
          page={page}
          perPage={perPage}
          handleChangePage={handleChangePage}
        />
      </div>
    );
  }
}

SharesFooter.propTypes = {
  sharesTotal: PropTypes.number.isRequired,
  page: PropTypes.number.isRequired,
  perPage: PropTypes.number.isRequired,
  handleChangePage: PropTypes.func.isRequired,
  handleChangePerPage: PropTypes.func.isRequired,
};

export default SharesFooter;
